<main id="content" class="site-main">
    <section class="package-inner-page">
      
       <!-- ***Inner Banner html end here*** -->
       <!-- ***career section html start form here*** -->
       <div class="inner-package-detail-wrap">
          <div class="container">
             <div class="row">
                <div class="col-lg-8 primary right-sidebar">
                   <div class="single-packge-wrap">
                      <div class="single-package-head d-flex align-items-center">
                         <div class="package-title">
                            <h2>Detalles del paquete {{getData().packageType}}</h2>
                            <div class="rating-start-wrap">
                               <div class="rating-start">
                                  <span style="width: 80%"></span>
                               </div>
                            </div>
                         </div>
                         <div class="package-price">
                            <h6 class="price-list">
                               <span>$750</span>
                               / per person
                            </h6>
                         </div>
                      </div>
                      <div class="package-meta">
                         <ul>
                            <li>
                               <i class="fas fa-clock"></i>
                               7D/6N
                            </li>
                            <li>
                               <i class="fas fa-user-friends"></i>
                               pax: 10
                            </li>
                            <li>
                               <i class="fas fa-swimmer"></i>
                               Category : Hangout
                            </li>

                            <li>
                               <i class="fas fa-map-marker-alt"></i>
                               Malaysia
                            </li>
                         </ul>
                      </div>
                      <figure class="single-package-image">
                         <img src="assets/images/img27.jpg" alt="">
                      </figure>
                      <div class="package-content-detail">
                         <article class="package-overview">
                            <h3>OVERVIEW :</h3>
                            <p>Malesuada incidunt excepturi proident quo eros? Id interdum praesent magnis, eius cumque? Integer aptent officiis recusandae habitasse iure, quisque culpa! Nemo et? Vel excepteur pellentesque morbi ducimus porro commodo sollicitudin, quidem, cupiditate ligula doloribus recusandae non, hac, ullam per, natus parturient sollicitudin! Facilis vestibulum accumsan quisquam excepturi explicabo.</p>
                            <p>Quam aut, luctus hendrerit, laborum, dolor, consectetur scelerisque quisque feugiat sequi, ea ipsa consequat atque consectetur. Litora aute error eos.Placerat habitasse nascetur sit voluptatem ea sint facilisis! Esse sed lacus! Sociosqu ullamcorper venenatis in.</p>
                         </article>
                         <article class="package-include bg-light-grey">
                            <h3>INCLUDE & EXCLUDE :</h3>
                            <ul>
                               <li><i class="fas fa-check"></i>Specialized bilingual guide</li>
                               <li><i class="fas fa-times"></i>Guide Service Fee</li>
                               <li><i class="fas fa-check"></i>Private Transport</li>
                               <li><i class="fas fa-times"></i>Room Service Fees</li>
                               <li><i class="fas fa-check"></i>Entrance Fees</li>
                               <li><i class="fas fa-times"></i>Driver Service Fee</li>
                               <li><i class="fas fa-check"></i>Breakfast And Lunch Box</li>
                               <li><i class="fas fa-times"></i>Any Private Expenses</li>
                            </ul>
                         </article>
                         <article class="package-ininerary">
                            <h3>ITINERARY :</h3>
                            <p>Malesuada incidunt excepturi proident quo eros? Id interdum praesent magnis, eius cumque? Integer aptent officiis recusandae habitasse iure, quisque culpa!</p>
                            <ul>
                               <li>
                                  <i aria-hidden="true" class="fas fa-dot-circle"></i>
                                  <span>DAY 1</span>
                                  Departure at the airport and arrival at the hotel
                               </li>
                               <li>
                                  <i aria-hidden="true" class="fas fa-dot-circle"></i>
                                  <span>DAY 2</span>
                                  Visit the main museums and lunch included
                               </li>
                               <li>
                                  <i aria-hidden="true" class="fas fa-dot-circle"></i>
                                  <span>DAY 3</span>
                                  Excursion in the natural oasis and picnic
                               </li>
                               <li>
                                  <i aria-hidden="true" class="fas fa-dot-circle"></i>
                                  <span>DAY 4</span>
                                  Transfer to the airport and return to the agency
                               </li>
                            </ul>
                         </article>
                      </div>
                   </div>
                </div>
                <div class="col-lg-4">
                   <div class="sidebar">
                      <div class="booking-form-wrap">
                         <div class="booking-form-inner primary-bg">
                            <h3>BOOKING FORM</h3>
                            <p>Malesuada incidunt excepturi proident quo eros? Sinterdum praesent magnis, eius cumque.</p>
                            
                         </div>
                      </div>
                      <div class="related-package">
                         <h3>RELATED IMAGES</h3>
                         <p>Quaerat inventore! Vestibulum aenean volutpat gravida. Sagittis, euismod perferendis.</p>
                         <div class="related-package-slide">
                            <div class="related-package-item">
                               <img src="assets/images/img1.jpg" alt="">
                            </div>
                            <div class="related-package-item">
                               <img src="assets/images/img2.jpg" alt="">
                            </div>
                        
                         </div>
                      </div>
                   
                      
                   </div>
                </div>
             </div>
          </div>
       </div>
       <!-- ***career section html start form here*** -->
    </section>
 </main>